import ReactDOM from 'react-dom/client';
import { TrincoProvider } from './contexto/contexto';
import Rotas from './rotas/rotas';
import './index.css'
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import ReactGA from "react-ga4";

ReactGA.initialize("G-KHGG146M9V");
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <TrincoProvider>
    <ConfigProvider locale={ptBR}>
      <Rotas />
    </ConfigProvider>
  </TrincoProvider>,
);



